import { render, staticRenderFns } from "./FriendsActivity.vue?vue&type=template&id=129fe43d&scoped=true&"
import script from "./FriendsActivity.vue?vue&type=script&lang=js&"
export * from "./FriendsActivity.vue?vue&type=script&lang=js&"
import style0 from "./FriendsActivity.vue?vue&type=style&index=0&id=129fe43d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129fe43d",
  null
  
)

export default component.exports